import { getLicenseTypeQuestionsOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { getForeclosureUnregisteredMatch } from "@/hera-api/foreclosure-license-link-api";
import {
  foreclosureCaseNumberQuestionId,
  foreclosurePartyQuestionId,
} from "@/lib/foreclosure-case-party-utils";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function useForeclosurePartyQuestionIds(
  jurisdictionId: string | null | undefined,
  portal: "government" | "operator" | undefined,
) {
  const licenseTypesQuery = useQuery({
    queryKey: ["foreclosure-party-license-types", portal, jurisdictionId],
    queryFn: () =>
      getForeclosureUnregisteredMatch(portal as "government" | "operator", {
        jurisdictionId: jurisdictionId ?? undefined,
      }),
    enabled: Boolean(jurisdictionId && portal),
  });

  const licenseTypeId =
    licenseTypesQuery.data?.foreclosure_license_types[0]?.license_type_id ??
    null;

  const questionsQuery = useQuery({
    ...getLicenseTypeQuestionsOptions({
      path: {
        license_type_id: licenseTypeId ?? "",
        jurisdiction_id: jurisdictionId ?? "",
      },
    }),
    enabled: Boolean(jurisdictionId && licenseTypeId),
  });

  return useMemo(() => {
    const questions = questionsQuery.data?.questions ?? [];
    return {
      omtQuestionId: foreclosurePartyQuestionId(questions, "OMT"),
      amsQuestionId: foreclosurePartyQuestionId(questions, "AMS"),
      caseNumberQuestionId: foreclosureCaseNumberQuestionId(questions),
      questions,
      licenseTypeId,
      isLoading:
        licenseTypesQuery.isLoading ||
        questionsQuery.isLoading ||
        licenseTypesQuery.isFetching ||
        questionsQuery.isFetching,
    };
  }, [
    licenseTypeId,
    licenseTypesQuery.isFetching,
    licenseTypesQuery.isLoading,
    questionsQuery.data?.questions,
    questionsQuery.isFetching,
    questionsQuery.isLoading,
  ]);
}
